/**
 * Created by Bart Decorte
 * Date: 2019-07-11
 * Time: 15:42
 */
import GalleryTile from '../../utils/GalleryTile';
import TablesShowElementDrag from './_partials/TablesShowElementDrag';

class TablesShowGallery extends TablesShowElementDrag {
  constructor() {
    const $form = $('.js-entry-form');
    super({ $root: $form });
    this.initGalleryTiles();
  }

  initGalleryTiles() {
    const tiles = [];
    const $tiles = $('.js-gallery-tile');

    for (let i = 0; i < $tiles.length; i++) {
      tiles.push(new GalleryTile({ $root: $($tiles[i]) }));
    }

    return tiles;
  }
}

export default TablesShowGallery;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/Tables/TablesShowGallery.js